import { FC } from 'react';
import SuperSelect from '../SuperSelect';
import SimpleFormItem from './subpage/simpleFormItem';
import { SelectOption, SelectValue, SuperSelectProps } from '../SuperSelect/interface';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { FormInstance, FormItemProps } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';

interface SuperSelectFormProps extends SuperSelectProps {
  onChange?: (value?: SelectValue, options?: SelectOption | SelectOption[], form?: FormInstance, index?: number, record?: any) => void;
}
export interface SimpleFormSuperSelectCombinationProps extends BaseSimpleFormProps {
  /** 前置下拉配置 */
  beforeSuperSelectProps?: SuperSelectFormProps;
  /** 后置下拉配置 */
  afterSuperSelectProps?: SuperSelectFormProps;
  /** 前置表单配置 */
  beforeFormItemProps?: FormItemProps;
  /** 后置表单配置 */
  afterFormItemProps?: FormItemProps;
  /** 选项取行数据的哪个字段 */
  optionFieldNames?: string[];
}
const SimpleFormSuperSelectCombination: FC<SimpleFormSuperSelectCombinationProps> = props => {
  const { disabledRender, beforeFormItemProps, afterFormItemProps, beforeSuperSelectProps, afterSuperSelectProps, form, label, rules, name, ...restProps } = props;
  let beforeName: NamePath | undefined = '';
  let afterName: NamePath | undefined = '';
  if (Array.isArray(name)) {
    beforeName = name[0];
    afterName = name[1];
  }
  return (
    <div className='select-combination'>
      <SimpleFormItem
        label={label}
        rules={rules}
        name={beforeName}
        style={{width: `calc(50% - 16px)`,}}
        {...restProps}
        {...beforeFormItemProps}
      >
        <SuperSelect
          allowClear
          showSearch
          placeholder={getSelectPlaceholder(label, beforeSuperSelectProps, rules)}
          {...beforeSuperSelectProps}
        />
      </SimpleFormItem>
      <div className='select-combination-split'>-</div>
      <SimpleFormItem
        label={label}
        rules={rules}
        name={afterName}
        style={{width: `calc(50% - 16px)`,}}
        {...restProps}
        {...afterFormItemProps}
      >
        <SuperSelect
          allowClear
          showSearch
          placeholder={getSelectPlaceholder(label, afterSuperSelectProps, rules)}
          {...afterSuperSelectProps}
        />
      </SimpleFormItem>
    </div>
  );
};

SimpleFormSuperSelectCombination.displayName = SimpleFormItemEnum.SimpleFormSuperSelectCombination;

export default SimpleFormSuperSelectCombination;
